import { ConsumerBulkInteractionModel } from './consumer-bulk-interaction.model';

export class BulkScreenMessageModel extends ConsumerBulkInteractionModel{
    message: string;
}
